import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\" id=\"icon-clock\">\n<path d=\"M10,2.2c-4.3,0-7.8,3.5-7.8,7.8s3.5,7.8,7.8,7.8s7.8-3.5,7.8-7.8S14.3,2.2,10,2.2z M13.1,12.1l-0.6,0.8\n\tc-0.1,0.2-0.4,0.2-0.5,0.1l-2.7-1.9c-0.1-0.1-0.2-0.2-0.2-0.3V5.6c0-0.2,0.2-0.4,0.4-0.4h1c0.2,0,0.4,0.2,0.4,0.4v4.5l2.1,1.5\n\tC13.2,11.7,13.2,11.9,13.1,12.1z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/clock.svg
// module id = z5wF
// module chunks = 97